import { useCsvParser } from '@/features/inventory/hooks/useCsvParser';

export interface PurchaseOrderCsvRow {
  sku: string;
  type?: string;
  color?: string;
  size?: string;
  current_stock?: number;
  order_quantity: number;
  rowNumber: number;
}

export function usePurchaseOrderCsvParser() {
  return useCsvParser<PurchaseOrderCsvRow>({
    requiredColumns: ['sku', 'order_quantity'],
    validateRow: (row) => {
      const sku = String(row.sku ?? '').trim();
      if (!sku) {
        return { valid: false, error: 'Missing SKU' };
      }

      const quantity = typeof row.order_quantity === 'number'
        ? row.order_quantity
        : Number(row.order_quantity);

      if (!Number.isFinite(quantity) || quantity <= 0) {
        return { valid: false, error: `Invalid order quantity for SKU ${sku}` };
      }

      return { valid: true };
    },
    transformRow: (row, index) => ({
      sku: String(row.sku ?? '').trim(),
      type: row.type ? String(row.type) : undefined,
      color: row.color ? String(row.color) : undefined,
      size: row.size ? String(row.size) : undefined,
      current_stock: typeof row.current_stock === 'number' ? row.current_stock : Number(row.current_stock || 0),
      order_quantity: typeof row.order_quantity === 'number' ? row.order_quantity : Number(row.order_quantity || 0),
      rowNumber: index + 1,
    }),
  });
}
